import getConfig from 'next/config';

import React, { Component } from 'react';
import Raven from 'raven-js';
import { withErrorHandler, FallbackView } from 'react-error-boundaries';

import bog from './moreBog';

const {
  publicRuntimeConfig: {
    sentryDsn: SENTRY_DSN,
    commit: COMMIT,
    buildId: BUILD_ID,
  },
} = getConfig();

const onError = (error, errorInfo, props) => {
  bog.error('withErrorHandler triggered', error, errorInfo);
  if (__DEV__) return;
  Raven.config(SENTRY_DSN, {
    release: COMMIT,
    tags: { BUILD_ID, COMMIT },
    environment: typeof window !== 'undefined' ? window.location.host : '',
    debug: !!__DEV__,
  }).install();
  Raven.captureException(error, { extra: { errorInfo, props } });
};

const withErrorHandlerDecorator = ChildComponent => class ErrorHandlerWrapper extends Component {
  constructor() {
    super();
    this.WrappedComponent = withErrorHandler(
      FallbackView, // Fallback Component to display errors, to replace default FallbackView
      ChildComponent, // Component to decorate
    );
  }

  render() {
    const { WrappedComponent } = this;
    return <WrappedComponent onError={onError} {...this.props} />;
  }
};

export default withErrorHandlerDecorator;
